import CCTerminal from 'app/src/data/models/CCTerminal';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class CCTerminalCollection extends RetailCollection {
  get model() {
    return CCTerminal;
  }

  /**
   * Return the REST url for collection of CCTerminal models
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/CCTerminal.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.CCTerminal is an array of the CCTerminal structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.CCTerminal || [];
  }
}
